/**
 * BRINUTI — LAPOK-ELLENŐRZŐ, TERMÉKOLDAL (2026-10-26, TESZT-téma)
 *
 * Az „Előnézet” ablakban két fül: Borító | Lapok. A Lapok-fül a kiválasztott
 * lapok valódi kétoldalas képét mutatja (nagyítóval), alatta a Szalag és a
 * Lapok egy-egy „Módosítom” gombbal – mind egy mobilképernyőn. Az ablak a
 * Teeinblue ablaka marad (MutationObserverrel építjük mellé, mert a Teeinblue
 * minden választásnál újrarendereli a blokkját), a fülek csak
 * elrejtik/megmutatják a saját galériáját.
 *
 * A lapok a Teeinblue rejtett legördülőjében élnek (a brinuti-tee-valaszto
 * kártya ugyanazt használja), a váltás is azon megy keresztül.
 *
 * Ha bármi hiányzik, csendben nem csinálunk semmit.
 */
(function () {
  'use strict';
  var B = window.BrinutiBeliv;
  if (!B) return;

  var esc = B.esc;
  var idozito = null;

  /* ---------- A lapok mező és az aktuális érték ---------- */
  function belivMezo() {
    return document.querySelector('#teeFormInputs > .tee-field[data-btv="beliv"]');
  }
  function belivSelect() {
    var f = belivMezo();
    return f ? f.querySelector('.tee-field__input select') : null;
  }
  function aktualis() {
    var sel = belivSelect();
    if (!sel || sel.selectedIndex < 0) return null;
    var o = sel.options[sel.selectedIndex];
    return o ? B.felismer(o.text) : null;
  }

  function szalagNev() {
    var n = document.querySelector('#teeFormInputs .btv-szalag-nev');
    var s = n ? n.textContent.replace(/^[\s·]+/, '').trim() : '';
    return s ? s.charAt(0).toUpperCase() + s.slice(1) : '';
  }

  /* A kosárból nyitott „Szerkesztés” ablakban (Teeinblue edit popup) a Teeinblue
     az oldal saját, MÁSIK űrlapjához kötött előnézetet nyit, nem a szerkesztetthez.
     Ott nem építünk fület és panelt, így a kosárban szerkesztett terméket és az
     oldal űrlapját semmi nem írhatja felül egymás helyett. */
  function szerkesztesNyitva() {
    var p = document.querySelector('.tee-edit-popup');
    return !!p && p.getClientRects().length > 0;
  }
  function takarit(dlg) {
    var body = dlg.querySelector('.tee-dcontent-body');
    var gal = dlg.querySelector('.tee-gallery-content');
    if (body) {
      Array.prototype.forEach.call(body.querySelectorAll(':scope > .bv-tabs, :scope > .bv-pane'), function (e) { e.remove(); });
      body.classList.remove('bv-body');
    }
    if (gal && gal.style.display === 'none') gal.style.display = '';
    dlg.removeAttribute('data-bv-tab');
  }

  /* ---------- Előnézeti ablak ---------- */
  function panelHtml(akt) {
    var szal = szalagNev();
    return '<p class="bv-pane__cim">Ilyen lapok lesznek benne</p>' +
      B.kepHtml(akt.k) +
      '<p class="bv-pane__le"><b>' + esc(akt.nev) + '</b> · ' + esc(akt.le) + '</p>' +
      '<ul class="bv-lista">' +
      (szal ? '<li><span class="bv-lista__k">Szalag:</span><b>' + esc(szal) + '</b><button type="button" class="bv-mod" data-bv-ugras="szalag">Módosítom</button></li>' : '') +
      '<li class="bv-lista__hot"><span class="bv-lista__k">Lapok:</span><b>' + esc(akt.nev) + '</b><button type="button" class="bv-mod" data-bv-ugras="beliv">Módosítom</button></li>' +
      '</ul>';
  }

  function elonezet(akt) {
    var dlg = document.querySelector('.tee-dialog-gallery .tee-dcontent');
    if (!dlg || !akt) return;
    if (szerkesztesNyitva()) { takarit(dlg); return; }
    var body = dlg.querySelector('.tee-dcontent-body');
    var gal = dlg.querySelector('.tee-gallery-content');
    if (!body || !gal) return;

    var ful = dlg.getAttribute('data-bv-tab') === 'beliv' ? 'beliv' : 'borito';
    /* A Teeinblue ablaktörzse vízszintes (flex row); a mi füleink és a
       lapok-panel alatta/fölötte, függőlegesen kell hogy álljanak. */
    if (!body.classList.contains('bv-body')) body.classList.add('bv-body');

    var fulok = body.querySelector(':scope > .bv-tabs');
    var fulHtml = '<button type="button" class="bv-tab' + (ful === 'borito' ? ' bv-tab--on' : '') + '" data-bv-fulvalt="borito">Borító</button>' +
      '<button type="button" class="bv-tab' + (ful === 'beliv' ? ' bv-tab--on' : '') + '" data-bv-fulvalt="beliv">Lapok</button>';
    if (!fulok) {
      fulok = document.createElement('div');
      fulok.className = 'bv-tabs';
      body.insertBefore(fulok, gal);
    }
    if (fulok.getAttribute('data-bv-jel') !== fulHtml) {
      fulok.innerHTML = fulHtml;
      fulok.setAttribute('data-bv-jel', fulHtml);
    }

    var pane = body.querySelector(':scope > .bv-pane');
    if (!pane) {
      pane = document.createElement('div');
      pane.className = 'bv-pane';
      /* A galéria ELÉ kell: az oldal egy beágyazott stílusa a
         `.tee-gallery-content ~ *` elemeket (a galéria utáni testvéreket)
         elrejti. */
      gal.parentNode.insertBefore(pane, gal);
    } else if (pane.nextElementSibling !== gal) {
      gal.parentNode.insertBefore(pane, gal);
    }
    /* Csak akkor építjük újra, ha a tartalom lényege változott (a kép
       betöltődése nem számít annak). */
    var jel = [akt.k, szalagNev()].join('|');
    if (pane.getAttribute('data-bv-jel') !== jel) {
      pane.innerHTML = panelHtml(akt);
      pane.setAttribute('data-bv-jel', jel);
    }
    B.kepBetolt(pane);
    var mutat = ful === 'beliv';
    if (pane.hidden === mutat) pane.hidden = !mutat;
    var galStilus = mutat ? 'none' : '';
    if (gal.style.display !== galStilus) gal.style.display = galStilus;
  }

  function dialogBezar() {
    var gombok = document.querySelectorAll('.tee-dcontent-footer button');
    for (var i = 0; i < gombok.length; i++) {
      if (/bezárása/i.test(gombok[i].textContent)) { gombok[i].click(); return true; }
    }
    return false;
  }

  function ugrasMezore(mit) {
    var cel = mit === 'szalag' ? document.querySelector('#teeFormInputs > .tee-field[data-btv="szalag"]') : belivMezo();
    if (!cel) return;
    cel.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var nyit = cel.querySelector('[data-btv-nyit]');
    if (nyit) setTimeout(function () { nyit.click(); }, 350);
  }

  function ugras(mit) {
    var voltDialog = !!document.querySelector('.tee-dialog-gallery .tee-dcontent');
    B.jelez('lapok_modositom_' + mit);
    if (!voltDialog) { ugrasMezore(mit); return; }

    /* Az előnézet ablakból a vevő a „Módosítom” gombbal az ablak MAGA FÖLÖTT
       nyitja a választó panelt (marad az előnézet a háttérben); ha a panel
       nem látszik felül, bezárjuk az ablakot és a mezőhöz görgetünk. */
    var mezo = mit === 'szalag' ? document.querySelector('#teeFormInputs > .tee-field[data-btv="szalag"]') :
      mit === 'beliv' ? belivMezo() : null;
    var nyit = mezo ? mezo.querySelector('[data-btv-nyit]') : null;
    if (nyit) {
      nyit.click();
      /* A választó panel z-indexe magasabb, mint az előnézeté, tehát felül
         nyílik. A panel a kattintás pillanatában kapja le a `hidden` jelzőt
         (az animáció csak ezután indul), ezért azonnal látszik, megnyílt-e;
         ha nem, a régi úton megyünk. */
      var panel = document.querySelector('.btv-panel');
      if (panel && !panel.hidden) return;
      dialogBezar();
      setTimeout(function () { ugrasMezore(mit); }, 300);
      return;
    }
    dialogBezar();
    setTimeout(function () { ugrasMezore(mit); }, 300);
  }

  /* ---------- Futtatás ---------- */
  function frissit() {
    elonezet(aktualis());
  }
  function halasztott() {
    clearTimeout(idozito);
    idozito = setTimeout(frissit, 120);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var fulGomb = t.closest('[data-bv-fulvalt]');
    if (fulGomb) {
      var dlg = fulGomb.closest('.tee-dcontent') || document.querySelector('.tee-dialog-gallery .tee-dcontent');
      if (dlg) {
        e.preventDefault();
        dlg.setAttribute('data-bv-tab', fulGomb.getAttribute('data-bv-fulvalt'));
        B.jelez('beliv_elonezet_' + fulGomb.getAttribute('data-bv-fulvalt'));
        frissit();
      }
      return;
    }
    var ug = t.closest('[data-bv-ugras]');
    if (ug) {
      e.preventDefault();
      ugras(ug.getAttribute('data-bv-ugras'));
    }
  }, true);

  ['input', 'change', 'click'].forEach(function (n) {
    document.addEventListener(n, halasztott, true);
  });

  function indul() {
    frissit();
    new MutationObserver(halasztott).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', indul);
  else indul();
})();